module.exports = __webpack_public_path__ + "img/reservation.ed18c1e3.jpg";